import { combineReducers } from 'redux';

import { maxWidthReducer as maxWidth } from './maxWidth';

export default combineReducers({
	maxWidth,
});
